import { Lang, Page, Operation } from "../translations/types";
import {
  EDIT_FORM_FIELDS_TRANSLATIONS,
  FORM_VALIDATION_TRANSLATIONS,
  getPageTranslationText,
} from "../translations/util";

const editTranslations = getPageTranslationText({
  lang: Lang.EN,
  page: Page.ORG,
  op: Operation.EDIT,
});

const editLocationTranslations = getPageTranslationText({
  lang: Lang.EN,
  page: Page.LOCATION,
  op: Operation.EDIT,
});

function fetchSquelchFieldsDropDownValues({
  fieldName,
  dfsiVersion,
  channelMode,
  ctcValue,
  cdcValue,
}: {
  fieldName?: string;
  dfsiVersion?: number;
  channelMode: string;
  ctcValue: string;
  cdcValue: string;
}) {
  let result = ["None"];
  if (channelMode && dfsiVersion && channelMode === "Analog") {
    if (dfsiVersion === 1) {
      result = ["None"];
    }
    if (dfsiVersion === 2) {
      if (fieldName === "CTC-SQUELCH-SYSTEM") {
        if (cdcValue && cdcValue !== "None") {
          result = ["None"];
        } else {
          result =
            EDIT_FORM_FIELDS_TRANSLATIONS[Page.DFSI_CHANNEL][
              "CTC-SQUELCH-SYSTEM"
            ].items;
        }
      } else if (ctcValue && ctcValue !== "None") {
        result = ["None"];
      } else {
        result =
          EDIT_FORM_FIELDS_TRANSLATIONS[Page.DFSI_CHANNEL]["CDC-SQUELCH-SYSTEM"]
            .items;
      }
    }
  }
  return result;
}

export const EDIT_XSSI_CONNECTION_FORM_FIELDS = [
  {
    cols: 2,
    fields: [
      {
        type: "TEXT",
        label:
          EDIT_FORM_FIELDS_TRANSLATIONS[Page.XSSI_CONNECTION]["RADIO-IPV4-ADDR"]
            .label,
        tooltipText:
          EDIT_FORM_FIELDS_TRANSLATIONS[Page.XSSI_CONNECTION]["RADIO-IPV4-ADDR"]
            .tooltipText,
        name: "RADIO-IPV4-ADDR",
        isInputInvalid: (val?: string) => {
          if (!val || val.length === 0) return true;
          if (
            !/^(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)$/.test(
              val
            )
          ) {
            return true;
          }
          return false;
        },
        invalidText: FORM_VALIDATION_TRANSLATIONS.IPV4Validation(
          EDIT_FORM_FIELDS_TRANSLATIONS[Page.XSSI_CONNECTION]["RADIO-IPV4-ADDR"]
            .label
        ),
      },
      {
        type: "HEX",
        label:
          EDIT_FORM_FIELDS_TRANSLATIONS[Page.XSSI_CONNECTION]["RADIO-RFSS-ID"]
            .label,
        tooltipText:
          EDIT_FORM_FIELDS_TRANSLATIONS[Page.XSSI_CONNECTION]["RADIO-RFSS-ID"]
            .tooltipText,
        name: "RADIO-RFSS-ID",
        min: 1,
        max: 65535,
      },
      {
        type: "HEX",
        label:
          EDIT_FORM_FIELDS_TRANSLATIONS[Page.XSSI_CONNECTION]["RADIO-SYSTEM-ID"]
            .label,
        tooltipText:
          EDIT_FORM_FIELDS_TRANSLATIONS[Page.XSSI_CONNECTION]["RADIO-SYSTEM-ID"]
            .tooltipText,
        name: "RADIO-SYSTEM-ID",
        min: 1,
        max: 4095,
      },
      {
        type: "HEX",
        label:
          EDIT_FORM_FIELDS_TRANSLATIONS[Page.XSSI_CONNECTION]["RADIO-WACN-ID"]
            .label,
        tooltipText:
          EDIT_FORM_FIELDS_TRANSLATIONS[Page.XSSI_CONNECTION]["RADIO-WACN-ID"]
            .tooltipText,
        name: "RADIO-WACN-ID",
        min: 1,
        max: 1048575,
      },
      {
        type: "TOGGLE",
        label:
          EDIT_FORM_FIELDS_TRANSLATIONS[Page.XSSI_CONNECTION][
            "RADIO-RFSS-4-HEX-DIGIT"
          ].label,
        tooltipText:
          EDIT_FORM_FIELDS_TRANSLATIONS[Page.XSSI_CONNECTION][
            "RADIO-RFSS-4-HEX-DIGIT"
          ].tooltipText,
        name: "RADIO-RFSS-4-HEX-DIGIT",
      },
    ],
  },
  {
    cols: 2,
    fields: [
      {
        type: "HEX",
        label:
          EDIT_FORM_FIELDS_TRANSLATIONS[Page.XSSI_CONNECTION]["IWF-RFSS-ID"]
            .label,
        tooltipText:
          EDIT_FORM_FIELDS_TRANSLATIONS[Page.XSSI_CONNECTION]["IWF-RFSS-ID"]
            .tooltipText,
        name: "IWF-RFSS-ID",
        min: 1,
        max: 65535,
      },
      {
        type: "HEX",
        label:
          EDIT_FORM_FIELDS_TRANSLATIONS[Page.XSSI_CONNECTION]["IWF-SYSTEM-ID"]
            .label,
        tooltipText:
          EDIT_FORM_FIELDS_TRANSLATIONS[Page.XSSI_CONNECTION]["IWF-SYSTEM-ID"]
            .tooltipText,
        name: "IWF-SYSTEM-ID",
        min: 1,
        max: 4095,
      },
      {
        type: "HEX",
        label:
          EDIT_FORM_FIELDS_TRANSLATIONS[Page.XSSI_CONNECTION]["IWF-WACN-ID"]
            .label,
        tooltipText:
          EDIT_FORM_FIELDS_TRANSLATIONS[Page.XSSI_CONNECTION]["IWF-WACN-ID"]
            .tooltipText,
        name: "IWF-WACN-ID",
        min: 1,
        max: 1048575,
      },
    ],
  },
  {
    cols: 2,
    fields: [
      {
        type: "TOGGLE",
        label:
          EDIT_FORM_FIELDS_TRANSLATIONS[Page.XSSI_CONNECTION]["POLLING-ENABLED"]
            .label,
        tooltipText:
          EDIT_FORM_FIELDS_TRANSLATIONS[Page.XSSI_CONNECTION]["POLLING-ENABLED"]
            .tooltipText,
        name: "POLLING-ENABLED",
      },
      {
        type: "NUMBER",
        label:
          EDIT_FORM_FIELDS_TRANSLATIONS[Page.XSSI_CONNECTION][
            "POLLING-INTERVAL-CONNECTED"
          ].label,
        tooltipText:
          EDIT_FORM_FIELDS_TRANSLATIONS[Page.XSSI_CONNECTION][
            "POLLING-INTERVAL-CONNECTED"
          ].tooltipText,
        name: "POLLING-INTERVAL-CONNECTED",
        min: 1,
        max: 300,
      },
      {
        type: "NUMBER",
        label:
          EDIT_FORM_FIELDS_TRANSLATIONS[Page.XSSI_CONNECTION][
            "POLLING-INTERVAL-DISCONNECTED"
          ].label,
        tooltipText:
          EDIT_FORM_FIELDS_TRANSLATIONS[Page.XSSI_CONNECTION][
            "POLLING-INTERVAL-DISCONNECTED"
          ].tooltipText,
        name: "POLLING-INTERVAL-DISCONNECTED",
        min: 1,
        max: 300,
      },
      {
        type: "NUMBER",
        label:
          EDIT_FORM_FIELDS_TRANSLATIONS[Page.XSSI_CONNECTION][
            "RESPONSES-BEFORE-CONNECTED"
          ].label,
        tooltipText:
          EDIT_FORM_FIELDS_TRANSLATIONS[Page.XSSI_CONNECTION][
            "RESPONSES-BEFORE-CONNECTED"
          ].tooltipText,
        name: "RESPONSES-BEFORE-CONNECTED",
        min: 1,
        max: 100,
      },
      {
        type: "NUMBER",
        label:
          EDIT_FORM_FIELDS_TRANSLATIONS[Page.XSSI_CONNECTION][
            "MISSED-RESPONSES-BEFORE-DISCONNECTED"
          ].label,
        tooltipText:
          EDIT_FORM_FIELDS_TRANSLATIONS[Page.XSSI_CONNECTION][
            "MISSED-RESPONSES-BEFORE-DISCONNECTED"
          ].tooltipText,
        name: "MISSED-RESPONSES-BEFORE-DISCONNECTED",
        min: 1,
        max: 100,
      },
      {
        type: "MULTISELECT",
        label:
          EDIT_FORM_FIELDS_TRANSLATIONS[Page.XSSI_CONNECTION]["VOCODER-MODES"]
            .label,
        tooltipText:
          EDIT_FORM_FIELDS_TRANSLATIONS[Page.XSSI_CONNECTION]["VOCODER-MODES"]
            .tooltipText,
        name: "VOCODER-MODES",
        invalidText: FORM_VALIDATION_TRANSLATIONS.VocoderValidation(
          EDIT_FORM_FIELDS_TRANSLATIONS[Page.XSSI_CONNECTION]["VOCODER-MODES"]
            .label
        ),
        isInputInvalid: (list?: string[] | string) => {
          if (!list || list.length === 0) return true;

          const POSSIBLE_VOCODER_MODES = ["FR", "HR", "Native", "Phase 1"];
          if (POSSIBLE_VOCODER_MODES.some((r) => list.includes(r)))
            return false;

          return true;
        },
      },
    ],
  },
];

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const EDIT_OTAR_CONNECTION_FORM_FIELDS: any = [
  {
    cols: 2,
    fields: [
      {
        type: "TEXT",
        label:
          EDIT_FORM_FIELDS_TRANSLATIONS[Page.OTAR_CONNECTION]["KMF-IPV4-ADDR"]
            .label,
        tooltipText:
          EDIT_FORM_FIELDS_TRANSLATIONS[Page.OTAR_CONNECTION]["KMF-IPV4-ADDR"]
            .tooltipText,
        name: "KMF-IPV4-ADDR",
        isInputInvalid: (val?: string) => {
          if (!val || val.length === 0) return true;
          if (
            !/^(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)$/.test(
              val
            )
          ) {
            return true;
          }

          return false;
        },
        invalidText: FORM_VALIDATION_TRANSLATIONS.IPV4Validation(
          EDIT_FORM_FIELDS_TRANSLATIONS[Page.OTAR_CONNECTION]["KMF-IPV4-ADDR"]
            .label
        ),
      },
      {
        type: "NUMBER",
        label:
          EDIT_FORM_FIELDS_TRANSLATIONS[Page.OTAR_CONNECTION]["KMF-PORT"].label,
        tooltipText:
          EDIT_FORM_FIELDS_TRANSLATIONS[Page.OTAR_CONNECTION]["KMF-PORT"]
            .tooltipText,
        name: "KMF-PORT",
        min: 1024,
        max: 65535,
      },
      {
        type: "NUMBER",
        label:
          EDIT_FORM_FIELDS_TRANSLATIONS[Page.OTAR_CONNECTION][
            "KMF-RADIO-SET-IDENTIFIER"
          ].label,
        tooltipText:
          EDIT_FORM_FIELDS_TRANSLATIONS[Page.OTAR_CONNECTION][
            "KMF-RADIO-SET-IDENTIFIER"
          ].tooltipText,
        name: "KMF-RADIO-SET-IDENTIFIER",
        min: 1,
        max: 9999999,
      },
      {
        type: "NUMBER",
        label:
          EDIT_FORM_FIELDS_TRANSLATIONS[Page.OTAR_CONNECTION][
            "IWF-RADIO-SET-IDENTIFIER"
          ].label,
        tooltipText:
          EDIT_FORM_FIELDS_TRANSLATIONS[Page.OTAR_CONNECTION][
            "IWF-RADIO-SET-IDENTIFIER"
          ].tooltipText,
        name: "IWF-RADIO-SET-IDENTIFIER",
        min: 1,
        max: 9999999,
      },
      {
        type: "NUMBER",
        label:
          EDIT_FORM_FIELDS_TRANSLATIONS[Page.OTAR_CONNECTION][
            "MESSAGE-NUMBER-PERIOD"
          ].label,
        tooltipText:
          EDIT_FORM_FIELDS_TRANSLATIONS[Page.OTAR_CONNECTION][
            "MESSAGE-NUMBER-PERIOD"
          ].tooltipText,
        name: "MESSAGE-NUMBER-PERIOD",
        min: 0,
        max: 65535,
      },
      {
        type: "NUMBER",
        label:
          EDIT_FORM_FIELDS_TRANSLATIONS[Page.OTAR_CONNECTION][
            "PRIVATE-CALL-SLN"
          ].label,
        tooltipText:
          EDIT_FORM_FIELDS_TRANSLATIONS[Page.OTAR_CONNECTION][
            "PRIVATE-CALL-SLN"
          ].tooltipText,
        name: "PRIVATE-CALL-SLN",
        min: 0,
        max: 4095,
      },
      {
        type: "NUMBER",
        label:
          EDIT_FORM_FIELDS_TRANSLATIONS[Page.OTAR_CONNECTION][
            "GROUP-REGROUP-SLN"
          ].label,
        tooltipText:
          EDIT_FORM_FIELDS_TRANSLATIONS[Page.OTAR_CONNECTION][
            "GROUP-REGROUP-SLN"
          ].tooltipText,
        name: "GROUP-REGROUP-SLN",
        min: 0,
        max: 4095,
      },
      {
        type: "NUMBER",
        label:
          EDIT_FORM_FIELDS_TRANSLATIONS[Page.OTAR_CONNECTION][
            "OTAR-REGISTRATION-TIMER"
          ].label,
        tooltipText:
          EDIT_FORM_FIELDS_TRANSLATIONS[Page.OTAR_CONNECTION][
            "OTAR-REGISTRATION-TIMER"
          ].tooltipText,
        name: "OTAR-REGISTRATION-TIMER",
        min: 1,
        max: 72,
      },
      {
        type: "NUMBER",
        label:
          EDIT_FORM_FIELDS_TRANSLATIONS[Page.OTAR_CONNECTION][
            "KEEP-ALIVE-TIMER"
          ].label,
        tooltipText:
          EDIT_FORM_FIELDS_TRANSLATIONS[Page.OTAR_CONNECTION][
            "KEEP-ALIVE-TIMER"
          ].tooltipText,
        name: "KEEP-ALIVE-TIMER",
        min: 0,
        max: 300,
      },
    ],
  },
  {
    cols: 3,
    fields: [
      {
        type: "TOGGLE",
        label:
          EDIT_FORM_FIELDS_TRANSLATIONS[Page.OTAR_CONNECTION][
            "OPT-SEND-REKEY-REQ"
          ].label,
        tooltipText:
          EDIT_FORM_FIELDS_TRANSLATIONS[Page.OTAR_CONNECTION][
            "OPT-SEND-REKEY-REQ"
          ].tooltipText,
        name: "OPT-SEND-REKEY-REQ",
      },
      {
        type: "TOGGLE",
        label:
          EDIT_FORM_FIELDS_TRANSLATIONS[Page.OTAR_CONNECTION][
            "OPT-DE-REGISTRATION"
          ].label,
        tooltipText:
          EDIT_FORM_FIELDS_TRANSLATIONS[Page.OTAR_CONNECTION][
            "OPT-DE-REGISTRATION"
          ].tooltipText,
        name: "OPT-DE-REGISTRATION",
      },
      {
        type: "TOGGLE",
        label:
          EDIT_FORM_FIELDS_TRANSLATIONS[Page.OTAR_CONNECTION][
            "OPT-REVERSE-WARM-START"
          ].label,
        tooltipText:
          EDIT_FORM_FIELDS_TRANSLATIONS[Page.OTAR_CONNECTION][
            "OPT-REVERSE-WARM-START"
          ].tooltipText,
        name: "OPT-REVERSE-WARM-START",
      },
      {
        type: "TOGGLE",
        label:
          EDIT_FORM_FIELDS_TRANSLATIONS[Page.OTAR_CONNECTION][
            "OPT-HELLO-MAC-REPLY"
          ].label,
        tooltipText:
          EDIT_FORM_FIELDS_TRANSLATIONS[Page.OTAR_CONNECTION][
            "OPT-HELLO-MAC-REPLY"
          ].tooltipText,
        name: "OPT-HELLO-MAC-REPLY",
      },
      {
        type: "TOGGLE",
        label:
          EDIT_FORM_FIELDS_TRANSLATIONS[Page.OTAR_CONNECTION][
            "OPT-KEY-ASSIGNMENT"
          ].label,
        tooltipText:
          EDIT_FORM_FIELDS_TRANSLATIONS[Page.OTAR_CONNECTION][
            "OPT-KEY-ASSIGNMENT"
          ].tooltipText,
        name: "OPT-KEY-ASSIGNMENT",
      },
    ],
  },
];

export const mappedFieldList = [
  {
    cols: 1,
    fields: [
      {
        name: EDIT_FORM_FIELDS_TRANSLATIONS[Page.MCPTT_USER]["MAPPED-P25-ID"]
          .label,
        label:
          EDIT_FORM_FIELDS_TRANSLATIONS[Page.MCPTT_USER]["MAPPED-P25-ID"].label,
        fieldTooltipText:
          EDIT_FORM_FIELDS_TRANSLATIONS[Page.MCPTT_USER]["MAPPED-P25-ID"]
            .tooltipText,
        placeHolder: "",
        isFieldRequired: false,
        isInputInvalid: (val: string) => {
          if (val && val.length !== 0) {
            return false;
          }
          return true;
        },
        invalidText: FORM_VALIDATION_TRANSLATIONS.required("MAPPED-P25-ID"),
      },
      {
        name: EDIT_FORM_FIELDS_TRANSLATIONS[Page.MCPTT_USER]["MAPPED-DMR-ID"]
          .label,
        label:
          EDIT_FORM_FIELDS_TRANSLATIONS[Page.MCPTT_USER]["MAPPED-DMR-ID"].label,
        fieldTooltipText:
          EDIT_FORM_FIELDS_TRANSLATIONS[Page.MCPTT_USER]["MAPPED-DMR-ID"]
            .tooltipText,
        placeHolder: "",
        isFieldRequired: false,
        isInputInvalid: (val: string) => {
          if (val && val.length !== 0) {
            return false;
          }
          return true;
        },
        invalidText: FORM_VALIDATION_TRANSLATIONS.required("MAPPED-DMR-ID"),
      },
      {
        name: EDIT_FORM_FIELDS_TRANSLATIONS[Page.MCPTT_USER]["MAPPED-ROIP-ID"]
          .label,
        label:
          EDIT_FORM_FIELDS_TRANSLATIONS[Page.MCPTT_USER]["MAPPED-ROIP-ID"]
            .label,
        fieldTooltipText:
          EDIT_FORM_FIELDS_TRANSLATIONS[Page.MCPTT_USER]["MAPPED-ROIP-ID"]
            .tooltipText,
        placeHolder: "",
        isFieldRequired: false,
        isInputInvalid: (val: string) => {
          if (val && val.length !== 0) {
            return false;
          }
          return true;
        },
        invalidText: FORM_VALIDATION_TRANSLATIONS.required("MAPPED-ROIP-ID"),
      },
      {
        name: EDIT_FORM_FIELDS_TRANSLATIONS[Page.MCPTT_USER]["MAPPED-DFSI-ID"]
          .label,
        label:
          EDIT_FORM_FIELDS_TRANSLATIONS[Page.MCPTT_USER]["MAPPED-DFSI-ID"]
            .label,
        fieldTooltipText:
          EDIT_FORM_FIELDS_TRANSLATIONS[Page.MCPTT_USER]["MAPPED-DFSI-ID"]
            .tooltipText,
        placeHolder: "",
        isFieldRequired: false,
        isInputInvalid: (val: string) => {
          if (val && val.length !== 0) {
            return false;
          }
          return true;
        },
        invalidText: FORM_VALIDATION_TRANSLATIONS.required("MAPPED-DFSI-ID"),
      },
    ],
  },
];

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const EDIT_MCPTT_USER_FORM_FIELDS: any = [
  {
    cols: 1,
    fields: [
      {
        type: "TEXT",
        label:
          EDIT_FORM_FIELDS_TRANSLATIONS[Page.MCPTT_USER]["DISPLAY-NAME"].label,
        tooltipText:
          EDIT_FORM_FIELDS_TRANSLATIONS[Page.MCPTT_USER]["DISPLAY-NAME"]
            .tooltipText,
        name: "DISPLAY-NAME",
        isInputInvalid: (val?: string) => {
          if (!val || val.length === 0) return true;
          return false;
        },
        invalidText: null,
      },
      {
        type: "MCUser_DROPDOWN",
        id: "SELECTED-MAPPED-FIELD",
        label:
          EDIT_FORM_FIELDS_TRANSLATIONS[Page.MCPTT_USER][
            "SELECT A MAPPED-FIELD"
          ].label,
        tooltipText:
          EDIT_FORM_FIELDS_TRANSLATIONS[Page.MCPTT_USER][
            "SELECT A MAPPED-FIELD"
          ].tooltipText,
        name: "SELECTED-MAPPED-FIELD",
        items:
          EDIT_FORM_FIELDS_TRANSLATIONS[Page.MCPTT_USER][
            "SELECT A MAPPED-FIELD"
          ].items,
        isInputInvalid: (val?: string) => !val || val?.length === 0,
        invalidText: null,
        required: true,
      },
      {
        type: "TOGGLE",
        label:
          EDIT_FORM_FIELDS_TRANSLATIONS[Page.MCPTT_USER]["MUTUAL-AID"].label,
        tooltipText:
          EDIT_FORM_FIELDS_TRANSLATIONS[Page.MCPTT_USER]["MUTUAL-AID"]
            .tooltipText,
        name: "MUTUAL-AID",
      },
    ],
  },
];

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const EDIT_MCPTT_GROUPS_FORM_FIELDS: any = [
  {
    cols: 1,
    fields: [
      {
        type: "MappedValueDropdown",
        label:
          EDIT_FORM_FIELDS_TRANSLATIONS[Page.MCPTT_GROUP][
            "SELECT A MAPPED-FIELD"
          ].label,
        tooltipText:
          EDIT_FORM_FIELDS_TRANSLATIONS[Page.MCPTT_GROUP][
            "SELECT A MAPPED-FIELD"
          ].tooltipText,
        name: "SELECT A MAPPED-FIELD",
        required: false,
        dropdownDisabled: true,
        items:
          EDIT_FORM_FIELDS_TRANSLATIONS[Page.MCPTT_GROUP][
            "SELECT A MAPPED-FIELD"
          ].items,
        placeholder:
          EDIT_FORM_FIELDS_TRANSLATIONS[Page.MCPTT_GROUP][
            "SELECT A MAPPED-FIELD"
          ].placeholder,
        isInputInvalid: (val?: string) => {
          if (!val || val.length === 0) return true;
          return false;
        },
      },
    ],
  },
];

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const EDIT_LMR_USERS_FORM_FIELDS: any = [
  {
    cols: 2,
    fields: [
      {
        type: "TEXT",
        label:
          EDIT_FORM_FIELDS_TRANSLATIONS[Page.LMR_USER]["LMR-NW-TYPE"].label,
        tooltipText:
          EDIT_FORM_FIELDS_TRANSLATIONS[Page.LMR_USER]["LMR-NW-TYPE"]
            .tooltipText,
        name: "LMR-NW-TYPE",
        isInputInvalid: (val?: string) => {
          if (!val || val.length === 0) return true;

          return false;
        },
        invalidText: null,
      },
      {
        type: "TEXT",
        label:
          EDIT_FORM_FIELDS_TRANSLATIONS[Page.LMR_USER]["MAPPED-MCPTT-ID"].label,
        tooltipText:
          EDIT_FORM_FIELDS_TRANSLATIONS[Page.LMR_USER]["MAPPED-MCPTT-ID"]
            .tooltipText,
        name: "MAPPED-MCPTT-ID",
        isInputInvalid: (val?: string) => {
          if (!val || val.length === 0) return true;

          return false;
        },
        invalidText: null,
      },
      {
        type: "TEXT",
        label:
          EDIT_FORM_FIELDS_TRANSLATIONS[Page.LMR_USER]["DISPLAY-NAME"].label,
        tooltipText:
          EDIT_FORM_FIELDS_TRANSLATIONS[Page.LMR_USER]["DISPLAY-NAME"]
            .tooltipText,
        name: "DISPLAY-NAME",
        isInputInvalid: (val?: string) => {
          if (!val || val.length === 0) return true;
          return false;
        },
        invalidText: null,
        required: true,
      },
      {
        type: "TOGGLE",
        label: EDIT_FORM_FIELDS_TRANSLATIONS[Page.LMR_USER]["MUTUAL-AID"].label,
        tooltipText:
          EDIT_FORM_FIELDS_TRANSLATIONS[Page.LMR_USER]["MUTUAL-AID"]
            .tooltipText,
        name: "MUTUAL-AID",
      },
    ],
  },
];

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const EDIT_LMR_GROUPS_FORM_FIELDS: any = [
  {
    cols: 2,
    fields: [
      {
        type: "DROPDOWN",
        label:
          EDIT_FORM_FIELDS_TRANSLATIONS[Page.LMR_GROUP]["LMR-NW-TYPE"].label,
        tooltipText:
          EDIT_FORM_FIELDS_TRANSLATIONS[Page.LMR_GROUP]["LMR-NW-TYPE"]
            .tooltipText,
        name: "LMR-NW-TYPE",
        items:
          EDIT_FORM_FIELDS_TRANSLATIONS[Page.LMR_GROUP]["LMR-NW-TYPE"].items,
        isInputInvalid: (val?: string) => !val || val.length === 0,
        invalidText: null,
      },
      {
        type: "TEXT",
        label:
          EDIT_FORM_FIELDS_TRANSLATIONS[Page.LMR_GROUP]["MAPPED-MCPTT-GID"]
            .label,
        tooltipText:
          EDIT_FORM_FIELDS_TRANSLATIONS[Page.LMR_GROUP]["MAPPED-MCPTT-GID"]
            .tooltipText,
        name: "MAPPED-MCPTT-GID",
        isInputInvalid: (val?: string) => !val || val.length === 0,
        invalidText: null,
      },
    ],
  },
];

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const EDIT_CANNED_MESSAGES_FORM_FIELDS: any = [
  {
    cols: 1,
    fields: [
      {
        type: "TEXTAREA",
        label:
          EDIT_FORM_FIELDS_TRANSLATIONS[Page.CANNED_MESSAGE]["CANNED-TEXT"]
            .label,
        tooltipText:
          EDIT_FORM_FIELDS_TRANSLATIONS[Page.CANNED_MESSAGE]["CANNED-TEXT"]
            .tooltipText,
        name: "CANNED-TEXT",
        isInputInvalid: (val?: string) => {
          if (!val || val.length === 0) return true;

          return false;
        },
        invalidText: null,
      },
    ],
  },
];

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const EDIT_REALTIME_PUBLISH_INFO_FORM_FIELDS: any = [
  {
    cols: 2,
    fields: [
      {
        type: "TEXT",
        label:
          EDIT_FORM_FIELDS_TRANSLATIONS[Page.PUBLISH_INFO]["GROUP-ID"].label,
        tooltipText:
          EDIT_FORM_FIELDS_TRANSLATIONS[Page.PUBLISH_INFO]["GROUP-ID"]
            .tooltipText,
        name: "GROUP-ID",
        isInputInvalid: (val?: string) => {
          if (!val || val.length === 0) return true;

          return false;
        },
        invalidText: null,
      },
      {
        type: "TEXT",
        label:
          EDIT_FORM_FIELDS_TRANSLATIONS[Page.PUBLISH_INFO]["USER-ID"].label,
        tooltipText:
          EDIT_FORM_FIELDS_TRANSLATIONS[Page.PUBLISH_INFO]["USER-ID"]
            .tooltipText,
        name: "USER-ID",
        isInputInvalid: (val?: string) => {
          if (!val || val.length === 0) return true;

          return false;
        },
        invalidText: null,
      },
      {
        type: "TEXT",
        label:
          EDIT_FORM_FIELDS_TRANSLATIONS[Page.PUBLISH_INFO]["SECS-TO-EXPIRE"]
            .label,
        tooltipText:
          EDIT_FORM_FIELDS_TRANSLATIONS[Page.PUBLISH_INFO]["SECS-TO-EXPIRE"]
            .tooltipText,
        name: "SECS-TO-EXPIRE",
        isInputInvalid: (val?: string) => {
          if (!val || val.length === 0) return true;

          return false;
        },
        invalidText: null,
      },
    ],
  },
];

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const EDIT_ORGANIZATION_FORM_FIELDS: any = [
  {
    cols: 1,
    fields: [
      {
        type: "TEXT",
        label: editTranslations.editableFields.labels.name,
        tooltipText: editTranslations.editableFields.tooltipText.name,
        name: editTranslations.editableFields.name.orgName,
        isInputInvalid: (val?: string) => {
          if (!val || val.length === 0) return true;

          return false;
        },
        invalidText: null,
      },
    ],
  },
];

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const EDIT_ORGANIZATION_PROFILE_FORM_FIELDS: any = [
  {
    cols: 1,
    fields: [
      {
        type: "NUMBER",
        label:
          EDIT_FORM_FIELDS_TRANSLATIONS[Page.ORG].GROUP_PROFILE["UNIT-SECURITY"]
            .label,
        tooltipText:
          EDIT_FORM_FIELDS_TRANSLATIONS[Page.ORG].GROUP_PROFILE["UNIT-SECURITY"]
            .tooltipText,
        name: "UNIT-SECURITY",
        min: 1,
        max: 3,
      },
      {
        type: "NUMBER",
        label:
          EDIT_FORM_FIELDS_TRANSLATIONS[Page.ORG].GROUP_PROFILE["UNIT-SLN"]
            .label,
        tooltipText:
          EDIT_FORM_FIELDS_TRANSLATIONS[Page.ORG].GROUP_PROFILE["UNIT-SLN"]
            .tooltipText,
        name: "UNIT-SLN",
        min: 0,
        max: 4095,
      },
    ],
  },
];

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const EDIT_LOCATIONS_FORM_FIELDS: any = [
  {
    cols: 2,
    fields: [
      {
        type: "TEXT",
        label: editLocationTranslations.readOnlyFields.labels.id,
        tooltipText: editLocationTranslations.readOnlyFields.tooltipText.idText,
        name: editLocationTranslations.readOnlyFields.name.id,
        isInputInvalid: (val?: string) => {
          if (!val || val.length === 0) return true;

          return false;
        },
        invalidText: null,
        disabled: true,
      },
      {
        type: "TEXT",
        label: editLocationTranslations.readOnlyFields.labels.name,
        tooltipText:
          editLocationTranslations.readOnlyFields.tooltipText.nameText,
        name: editLocationTranslations.readOnlyFields.name.locationName,
        isInputInvalid: (val?: string) => {
          if (!val || val.length === 0) return true;

          return false;
        },
        invalidText: null,
        disabled: true,
      },
      {
        type: "TEXT",
        label: editLocationTranslations.editableFields.labels.domain,
        tooltipText: editLocationTranslations.editableFields.tooltipText.domain,
        name: editLocationTranslations.editableFields.name.domain,
        isInputInvalid: (val?: string) => {
          if (!val || val.length === 0) return true;

          return false;
        },
        invalidText: null,
      },
    ],
  },
];

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const EDIT_ORGANIZATION_MAPPING_FORM_FIELDS: any = [
  {
    cols: 2,
    fields: [
      {
        type: "TEXT",
        label: EDIT_FORM_FIELDS_TRANSLATIONS[Page.ORG_MAPPING]["IWF-ID"].label,
        tooltipText:
          EDIT_FORM_FIELDS_TRANSLATIONS[Page.ORG_MAPPING]["IWF-ID"].tooltipText,
        name: "IWF-ID",
        isInputInvalid: (val?: string) => {
          if (!val || val.length === 0) return true;

          return false;
        },
        invalidText: null,
      },
      {
        type: "TEXT",
        label: EDIT_FORM_FIELDS_TRANSLATIONS[Page.ORG_MAPPING]["ORG-ID"].label,
        tooltipText:
          EDIT_FORM_FIELDS_TRANSLATIONS[Page.ORG_MAPPING]["ORG-ID"].tooltipText,
        name: "ORG-ID",
        isInputInvalid: (val?: string) => {
          if (!val || val.length === 0) return true;

          return false;
        },
        invalidText: null,
      },
    ],
  },
];

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const EDIT_ORGANISATION_TRANSLATION_FORM_FIELDS: any = [
  {
    cols: 2,
    fields: [
      {
        type: "NUMBER",
        label: EDIT_FORM_FIELDS_TRANSLATIONS[Page.ORG_TRANSLATION].FROM.label,
        tooltipText:
          EDIT_FORM_FIELDS_TRANSLATIONS[Page.ORG_TRANSLATION].FROM.tooltipText,
        name: "FROM",
        min: Number.MIN_SAFE_INTEGER,
        max: 2147483647,
        invalidText: `${
          EDIT_FORM_FIELDS_TRANSLATIONS[Page.ORG_TRANSLATION].FROM.label
        } ${FORM_VALIDATION_TRANSLATIONS.lessThan} 2147483647`,
      },
      {
        type: "TOGGLE",
        label: EDIT_FORM_FIELDS_TRANSLATIONS[Page.ORG_TRANSLATION].EFI.label,
        tooltipText:
          EDIT_FORM_FIELDS_TRANSLATIONS[Page.ORG_TRANSLATION].EFI.tooltipText,
        name: "EFI",
      },
      {
        type: "TOGGLE",
        label: EDIT_FORM_FIELDS_TRANSLATIONS[Page.ORG_TRANSLATION].EFO.label,
        tooltipText:
          EDIT_FORM_FIELDS_TRANSLATIONS[Page.ORG_TRANSLATION].EFO.tooltipText,
        name: "EFO",
      },
      {
        type: "NUMBER",
        label: EDIT_FORM_FIELDS_TRANSLATIONS[Page.ORG_TRANSLATION].TO.label,
        tooltipText:
          EDIT_FORM_FIELDS_TRANSLATIONS[Page.ORG_TRANSLATION].TO.tooltipText,
        name: "TO",
        min: Number.MIN_SAFE_INTEGER,
        max: 2147483647,
        invalidText: `${
          EDIT_FORM_FIELDS_TRANSLATIONS[Page.ORG_TRANSLATION].TO.label
        } ${FORM_VALIDATION_TRANSLATIONS.lessThan} 2147483647`,
      },
    ],
  },
];

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const EDIT_DFSI_CONNECTION_FORM_FIELDS: any = [
  {
    cols: 2,
    fields: [
      {
        type: "TEXT",
        label:
          EDIT_FORM_FIELDS_TRANSLATIONS[Page.DFSI_CONNECTION][
            "HOST-CONTROL-IPV4-ADDR"
          ].label,
        tooltipText:
          EDIT_FORM_FIELDS_TRANSLATIONS[Page.DFSI_CONNECTION][
            "HOST-CONTROL-IPV4-ADDR"
          ].tooltipText,
        name: "HOST-CONTROL-IPV4-ADDR",
        isInputInvalid: ({
          val,
          role,
        }: {
          version?: number;
          val?: string;
          role?: string;
        }) => {
          if (role === "Station") return false;
          if (!val || val.length === 0) return true;
          if (
            !/^(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)$/.test(
              val
            )
          ) {
            return true;
          }

          return false;
        },
        invalidText: FORM_VALIDATION_TRANSLATIONS.IPV4Validation(
          EDIT_FORM_FIELDS_TRANSLATIONS[Page.DFSI_CONNECTION][
            "HOST-CONTROL-IPV4-ADDR"
          ].label
        ),
        disabled: (dfsiVersion?: number, role?: string) => {
          if (!dfsiVersion && !role) return true;
          return role === "Station";
        },
      },
      {
        type: "NUMBER",
        label:
          EDIT_FORM_FIELDS_TRANSLATIONS[Page.DFSI_CONNECTION][
            "HOST-CONTROL-PORT"
          ].label,
        tooltipText:
          EDIT_FORM_FIELDS_TRANSLATIONS[Page.DFSI_CONNECTION][
            "HOST-CONTROL-PORT"
          ].tooltipText,
        name: "HOST-CONTROL-PORT",
        min: 1024,
        max: 65535,
        isInputInvalid: ({
          val,
          role,
        }: {
          version?: number;
          val?: number;
          role?: string;
        }) => {
          if (role === "Station") return false;
          if (!val) return true;

          return val < 1024 || val > 65535;
        },
        disabled: (dfsiVersion?: number, role?: string) => {
          if (!dfsiVersion && !role) return true;
          return role === "Station";
        },
      },
      {
        type: "TEXT",
        label:
          EDIT_FORM_FIELDS_TRANSLATIONS[Page.DFSI_CONNECTION][
            "HOST-VOICE-IPV4-ADDR"
          ].label,
        tooltipText:
          EDIT_FORM_FIELDS_TRANSLATIONS[Page.DFSI_CONNECTION][
            "HOST-VOICE-IPV4-ADDR"
          ].tooltipText,
        name: "HOST-VOICE-IPV4-ADDR",
        isInputInvalid: ({
          val,
          role,
        }: {
          version?: number;
          val?: string;
          role?: string;
        }) => {
          if (role === "Station") return false;
          if (!val || val.length === 0) return true;
          if (
            !/^(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)$/.test(
              val
            )
          ) {
            return true;
          }

          return false;
        },
        invalidText: FORM_VALIDATION_TRANSLATIONS.IPV4Validation(
          EDIT_FORM_FIELDS_TRANSLATIONS[Page.DFSI_CONNECTION][
            "HOST-VOICE-IPV4-ADDR"
          ].label
        ),
        disabled: (dfsiVersion?: number, role?: string) => {
          if (!dfsiVersion && !role) return true;
          return role === "Station";
        },
      },
      {
        type: "NUMBER",
        label:
          EDIT_FORM_FIELDS_TRANSLATIONS[Page.DFSI_CONNECTION]["VOICE-PORT"]
            .label,
        tooltipText:
          EDIT_FORM_FIELDS_TRANSLATIONS[Page.DFSI_CONNECTION]["VOICE-PORT"]
            .tooltipText,
        name: "VOICE-PORT",
        min: 1024,
        max: 65535,
        isInputInvalid: ({ val }: { version?: number; val?: number }) => {
          if (!val) return true;

          return val < 1024 || val > 65535;
        },
      },

      {
        type: "TEXT",
        label:
          EDIT_FORM_FIELDS_TRANSLATIONS[Page.DFSI_CONNECTION]["DATA-IPV4-ADDR"]
            .label,
        tooltipText:
          EDIT_FORM_FIELDS_TRANSLATIONS[Page.DFSI_CONNECTION]["DATA-IPV4-ADDR"]
            .tooltipText,
        name: "DATA-IPV4-ADDR",
        isInputInvalid: ({
          version,
          val,
        }: {
          version?: number;
          val?: string;
        }) => {
          if (version === 1) return false;
          if (!val || val.length === 0) return true;
          if (
            !/^(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)$/.test(
              val
            )
          ) {
            return true;
          }

          return false;
        },
        invalidText: FORM_VALIDATION_TRANSLATIONS.IPV4Validation(
          EDIT_FORM_FIELDS_TRANSLATIONS[Page.DFSI_CONNECTION]["DATA-IPV4-ADDR"]
            .label
        ),
        disabled: (dfsiVersion?: number, role?: string) => {
          if (!dfsiVersion && !role) return true;
          return dfsiVersion && +dfsiVersion === 1;
        },
      },
      {
        type: "NUMBER",
        label:
          EDIT_FORM_FIELDS_TRANSLATIONS[Page.DFSI_CONNECTION]["DATA-PORT"]
            .label,
        tooltipText:
          EDIT_FORM_FIELDS_TRANSLATIONS[Page.DFSI_CONNECTION]["DATA-PORT"]
            .tooltipText,
        name: "DATA-PORT",
        min: 1024,
        max: 65535,
        isInputInvalid: ({
          val,
          version,
        }: {
          version?: number;
          val?: number;
        }) => {
          if (version === 1) return false;

          if (!val) return true;

          return val < 1024 || val > 65535;
        },
        disabled: (dfsiVersion?: number, role?: string) => {
          if (+!dfsiVersion && !role) return true;
          return dfsiVersion && +dfsiVersion === 1;
        },
      },
      {
        type: "TEXT",
        label:
          EDIT_FORM_FIELDS_TRANSLATIONS[Page.DFSI_CONNECTION][
            "FIXED-STATION-CONTROL-IPV4-ADDR"
          ].label,
        tooltipText:
          EDIT_FORM_FIELDS_TRANSLATIONS[Page.DFSI_CONNECTION][
            "FIXED-STATION-CONTROL-IPV4-ADDR"
          ].tooltipText,
        name: "FIXED-STATION-CONTROL-IPV4-ADDR",
        isInputInvalid: ({ val }: { version?: number; val?: string }) => {
          if (!val || val.length === 0) return true;
          if (
            !/^(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)$/.test(
              val
            )
          ) {
            return true;
          }

          return false;
        },
        invalidText: FORM_VALIDATION_TRANSLATIONS.IPV4Validation(
          EDIT_FORM_FIELDS_TRANSLATIONS[Page.DFSI_CONNECTION][
            "FIXED-STATION-CONTROL-IPV4-ADDR"
          ].label
        ),
      },
      {
        type: "TEXT",
        label:
          EDIT_FORM_FIELDS_TRANSLATIONS[Page.DFSI_CONNECTION][
            "FIXED-STATION-VOICE-IPV4-ADDR"
          ].label,
        tooltipText:
          EDIT_FORM_FIELDS_TRANSLATIONS[Page.DFSI_CONNECTION][
            "FIXED-STATION-VOICE-IPV4-ADDR"
          ].tooltipText,
        name: "FIXED-STATION-VOICE-IPV4-ADDR",
        isInputInvalid: ({
          version,
          val,
          role,
        }: {
          version?: number;
          val?: string;
          role?: string;
        }) => {
          if (version === 2 && role === "Host") return false;
          if (!val || val.length === 0) return true;
          if (
            !/^(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)$/.test(
              val
            )
          ) {
            return true;
          }

          return false;
        },
        invalidText: FORM_VALIDATION_TRANSLATIONS.IPV4Validation(
          EDIT_FORM_FIELDS_TRANSLATIONS[Page.DFSI_CONNECTION][
            "FIXED-STATION-VOICE-IPV4-ADDR"
          ].label
        ),
        disabled: (dfsiVersion?: number, role?: string) => {
          if (!dfsiVersion) return true;
          return dfsiVersion && +dfsiVersion === 2 && role === "Host";
        },
      },
      {
        type: "NUMBER",
        label:
          EDIT_FORM_FIELDS_TRANSLATIONS[Page.DFSI_CONNECTION][
            "FIXED-STATION-CONTROL-PORT"
          ].label,
        tooltipText:
          EDIT_FORM_FIELDS_TRANSLATIONS[Page.DFSI_CONNECTION][
            "FIXED-STATION-CONTROL-PORT"
          ].tooltipText,
        name: "FIXED-STATION-CONTROL-PORT",
        min: 1024,
        max: 65535,
        isInputInvalid: ({ val }: { version?: number; val?: number }) => {
          if (!val) return true;

          return val < 1024 || val > 65535;
        },
      },
      {
        type: "NUMBER",
        label:
          EDIT_FORM_FIELDS_TRANSLATIONS[Page.DFSI_CONNECTION][
            "CONNECTIVITY-TX-TIMER"
          ].label,
        tooltipText:
          EDIT_FORM_FIELDS_TRANSLATIONS[Page.DFSI_CONNECTION][
            "CONNECTIVITY-TX-TIMER"
          ].tooltipText,
        name: "CONNECTIVITY-TX-TIMER",
        min: 1,
        max: 255,
        isInputInvalid: ({
          version,
          val,
          role,
        }: {
          version?: number;
          val?: number;
          role?: string;
        }) => {
          if (version === 1) return false;
          if (version === 2 && role === "Station") return false;
          if (!val) return true;
          return val < 1 || val > 255;
        },
        disabled: (dfsiVersion?: number, role?: string) => {
          if (!dfsiVersion || dfsiVersion === 1) return true;
          return +dfsiVersion === 2 && role === "Station";
        },
      },
      {
        type: "NUMBER",
        label:
          EDIT_FORM_FIELDS_TRANSLATIONS[Page.DFSI_CONNECTION][
            "CONNECTIVITY-LOSS-LIMIT"
          ].label,
        tooltipText:
          EDIT_FORM_FIELDS_TRANSLATIONS[Page.DFSI_CONNECTION][
            "CONNECTIVITY-LOSS-LIMIT"
          ].tooltipText,
        name: "CONNECTIVITY-LOSS-LIMIT",
        min: 1,
        max: 100,
        isInputInvalid: ({ val }: { version?: number; val?: number }) => {
          if (!val) return true;

          return val < 1 || val > 100;
        },
      },
      {
        type: "NUMBER",
        label:
          EDIT_FORM_FIELDS_TRANSLATIONS[Page.DFSI_CONNECTION][
            "FS-HEARTBEAT-PERIOD"
          ].label,
        tooltipText:
          EDIT_FORM_FIELDS_TRANSLATIONS[Page.DFSI_CONNECTION][
            "FS-HEARTBEAT-PERIOD"
          ].tooltipText,
        name: "FS-HEARTBEAT-PERIOD",
        min: 1,
        max: 255,
        isInputInvalid: ({
          val,
          version,
          role,
        }: {
          version?: number;
          val?: number;
          role?: string;
        }) => {
          if (version === 2 || (version === 1 && role === "Station"))
            return false;

          if (!val) return true;

          return val < 1 || val > 255;
        },
        disabled: (dfsiVersion?: number, role?: string) => {
          if (!dfsiVersion) return true;
          return (
            +dfsiVersion === 2 || (+dfsiVersion === 1 && role === "Station")
          );
        },
      },
      {
        type: "NUMBER",
        label:
          EDIT_FORM_FIELDS_TRANSLATIONS[Page.DFSI_CONNECTION][
            "HOST-HEARTBEAT-PERIOD"
          ].label,
        tooltipText:
          EDIT_FORM_FIELDS_TRANSLATIONS[Page.DFSI_CONNECTION][
            "HOST-HEARTBEAT-PERIOD"
          ].tooltipText,
        name: "HOST-HEARTBEAT-PERIOD",
        min: 1,
        max: 255,
        isInputInvalid: ({
          val,
          version,
          role,
        }: {
          version?: number;
          val?: number;
          role?: string;
        }) => {
          if (version === 2 || (version === 1 && role === "Station"))
            return false;

          if (!val) return true;

          return val < 1 || val > 255;
        },
        disabled: (dfsiVersion?: number, role?: string) => {
          if (!dfsiVersion) return true;
          return (
            +dfsiVersion === 2 || (+dfsiVersion === 1 && role === "Station")
          );
        },
      },
      {
        type: "NUMBER",
        label:
          EDIT_FORM_FIELDS_TRANSLATIONS[Page.DFSI_CONNECTION][
            "CONTROL-RETRY-TIME"
          ].label,
        tooltipText:
          EDIT_FORM_FIELDS_TRANSLATIONS[Page.DFSI_CONNECTION][
            "CONTROL-RETRY-TIME"
          ].tooltipText,
        name: "CONTROL-RETRY-TIME",
        min: 1,
        max: 5000,
        isInputInvalid: ({ val }: { version?: number; val?: number }) => {
          if (!val) return true;

          return val < 1 || val > 5000;
        },
      },
      {
        type: "NUMBER",
        label:
          EDIT_FORM_FIELDS_TRANSLATIONS[Page.DFSI_CONNECTION][
            "CONTROL-ATTEMPT-LIMIT"
          ].label,
        tooltipText:
          EDIT_FORM_FIELDS_TRANSLATIONS[Page.DFSI_CONNECTION][
            "CONTROL-ATTEMPT-LIMIT"
          ].tooltipText,
        name: "CONTROL-ATTEMPT-LIMIT",
        min: 1,
        max: 10,
        isInputInvalid: ({ val }: { version?: number; val?: number }) => {
          if (!val) return true;

          return val < 1 || val > 10;
        },
      },
      {
        type: "NUMBER",
        label:
          EDIT_FORM_FIELDS_TRANSLATIONS[Page.DFSI_CONNECTION][
            "OUTBOUND-MAX-CAI-DATA-BLOCKS"
          ].label,
        tooltipText:
          EDIT_FORM_FIELDS_TRANSLATIONS[Page.DFSI_CONNECTION][
            "OUTBOUND-MAX-CAI-DATA-BLOCKS"
          ].tooltipText,
        name: "OUTBOUND-MAX-CAI-DATA-BLOCKS",
        min: 1,
        max: 128,
        isInputInvalid: ({
          val,
          version,
        }: {
          version?: number;
          val?: number;
        }) => {
          if (version === 1) return false;

          if (!val) return true;

          return val < 1 || val > 128;
        },
        disabled: (dfsiVersion?: number) => {
          if (!dfsiVersion) return true;
          return +dfsiVersion === 1;
        },
      },
      {
        type: "NUMBER",
        label:
          EDIT_FORM_FIELDS_TRANSLATIONS[Page.DFSI_CONNECTION][
            "INBOUND-MAX-CAI-DATA-BLOCKS"
          ].label,
        tooltipText:
          EDIT_FORM_FIELDS_TRANSLATIONS[Page.DFSI_CONNECTION][
            "INBOUND-MAX-CAI-DATA-BLOCKS"
          ].tooltipText,
        name: "INBOUND-MAX-CAI-DATA-BLOCKS",
        min: 1,
        max: 128,
        isInputInvalid: ({
          val,
          version,
        }: {
          version?: number;
          val?: number;
        }) => {
          if (version === 1) return false;
          if (!val) return true;

          return val < 1 || val > 128;
        },
        disabled: (dfsiVersion?: number) => {
          if (!dfsiVersion) return true;
          return +dfsiVersion === 1;
        },
      },
      {
        type: "NUMBER",
        label:
          EDIT_FORM_FIELDS_TRANSLATIONS[Page.DFSI_CONNECTION][
            "ACKNOWLEDGEMENT-DELAY"
          ].label,
        tooltipText:
          EDIT_FORM_FIELDS_TRANSLATIONS[Page.DFSI_CONNECTION][
            "ACKNOWLEDGEMENT-DELAY"
          ].tooltipText,
        name: "ACKNOWLEDGEMENT-DELAY",
        min: 0,
        max: 2,
        isInputInvalid: ({ val }: { version?: number; val?: number }) => {
          if (!val && val !== 0) return true;

          return val < 0 || val > 2;
        },
      },
      {
        type: "TOGGLE",
        label:
          EDIT_FORM_FIELDS_TRANSLATIONS[Page.DFSI_CONNECTION]["INBOUND-REPEAT"]
            .label,
        tooltipText:
          EDIT_FORM_FIELDS_TRANSLATIONS[Page.DFSI_CONNECTION]["INBOUND-REPEAT"]
            .tooltipText,
        name: "INBOUND-REPEAT",
      },
      {
        type: "NUMBER",
        label:
          EDIT_FORM_FIELDS_TRANSLATIONS[Page.DFSI_CONNECTION][
            "FIXED-STATION-VOTER-REPORTING-PERIOD"
          ].label,
        tooltipText:
          EDIT_FORM_FIELDS_TRANSLATIONS[Page.DFSI_CONNECTION][
            "FIXED-STATION-VOTER-REPORTING-PERIOD"
          ].tooltipText,
        name: "FIXED-STATION-VOTER-REPORTING-PERIOD",
        min: 1,
        max: 255,
        isInputInvalid: ({ val, role }: { val?: number; role?: string }) => {
          if (role === "Host") return false;
          if (!val) return true;
          return val < 1 || val > 255;
        },
        disabled: (dfsiVersion?: number, role?: string) => {
          if (+!dfsiVersion || !role) return true;
          return (
            (role === "Host" && dfsiVersion === 1) ||
            (role === "Host" && dfsiVersion === 2)
          );
        },
      },
      {
        type: "NUMBER",
        label:
          EDIT_FORM_FIELDS_TRANSLATIONS[Page.DFSI_CONNECTION][
            "FIXED-STATION-TRANSMITTER-REPORT-INTERVAL"
          ].label,
        tooltipText:
          EDIT_FORM_FIELDS_TRANSLATIONS[Page.DFSI_CONNECTION][
            "FIXED-STATION-TRANSMITTER-REPORT-INTERVAL"
          ].tooltipText,
        name: "FIXED-STATION-TRANSMITTER-REPORT-INTERVAL",
        min: 1,
        max: 255,
        isInputInvalid: ({
          version,
          val,
          role,
        }: {
          version?: number;
          val?: number;
          role?: string;
        }) => {
          if (
            (role === "Host" && version === 1) ||
            (role === "Host" && version === 2) ||
            (role === "Station" && version === 1)
          ) {
            return false;
          }
          if (!val) return true;
          return val < 1 || val > 255;
        },
        disabled: (dfsiVersion?: number, role?: string) => {
          if (+!dfsiVersion || !role) return true;
          return (
            (role === "Host" && dfsiVersion === 1) ||
            (role === "Host" && dfsiVersion === 2) ||
            (role === "Station" && dfsiVersion === 1)
          );
        },
      },
    ],
  },
];

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const EDIT_DFSI_CHANNEL_FORM_FIELDS: any = [
  {
    cols: 2,
    fields: [
      {
        type: "DROPDOWN",
        label:
          EDIT_FORM_FIELDS_TRANSLATIONS[Page.DFSI_CHANNEL]["CHANNEL-MODE"]
            .label,
        tooltipText:
          EDIT_FORM_FIELDS_TRANSLATIONS[Page.DFSI_CHANNEL]["CHANNEL-MODE"]
            .tooltipText,
        name: "CHANNEL-MODE",
        items: ["Analog", "Digital"],
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        isInputInvalid: (val?: string, _?: string) => {
          if (!val) return true;

          return !(val === "Analog" || val === "Digital");
        },
      },
      {
        type: "CHECKBOX",
        label:
          EDIT_FORM_FIELDS_TRANSLATIONS[Page.DFSI_CHANNEL]["CARRIER-SQUELCH"]
            .label,
        tooltipText:
          EDIT_FORM_FIELDS_TRANSLATIONS[Page.DFSI_CHANNEL]["CARRIER-SQUELCH"]
            .tooltipText,
        name: "CARRIER-SQUELCH",
        disabled: (channelMode?: string, dfsiVersion?: number) => {
          if (!channelMode || channelMode === "Digital") {
            return true;
          }
          if (!channelMode || channelMode === "Analog") {
            if (!dfsiVersion || dfsiVersion === 1) {
              return true;
            }
          }
          return false;
        },
        isInputInvalid: (channelMode?: string, dfsiVersion?: number) => {
          if (!channelMode && !dfsiVersion) return true;
          return false;
        },
        invalidText: null,
      },
      {
        type: "COMBO-DROPDOWN",
        label:
          EDIT_FORM_FIELDS_TRANSLATIONS[Page.DFSI_CHANNEL]["CTC-SQUELCH-SYSTEM"]
            .label,
        tooltipText:
          EDIT_FORM_FIELDS_TRANSLATIONS[Page.DFSI_CHANNEL]["CTC-SQUELCH-SYSTEM"]
            .tooltipText,
        name: "CTC-SQUELCH-SYSTEM",
        comboItems: fetchSquelchFieldsDropDownValues,
        disabled: (
          channelMode?: string,
          dfsiVersion?: number,
          isChecked?: boolean
        ) => {
          return !channelMode || channelMode === "Digital" || isChecked;
        },
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        isInputInvalid: (channelMode?: string, val?: any) => {
          if (!channelMode) return true;
          if (channelMode === "Digital") return false;
          if (channelMode === "Analog" && val === 0) return false;
          return !val || val.length === 0;
        },
      },
      {
        type: "COMBO-DROPDOWN",
        label:
          EDIT_FORM_FIELDS_TRANSLATIONS[Page.DFSI_CHANNEL]["CDC-SQUELCH-SYSTEM"]
            .label,
        tooltipText:
          EDIT_FORM_FIELDS_TRANSLATIONS[Page.DFSI_CHANNEL]["CDC-SQUELCH-SYSTEM"]
            .tooltipText,
        name: "CDC-SQUELCH-SYSTEM",
        comboItems: fetchSquelchFieldsDropDownValues,
        disabled: (
          channelMode?: string,
          dfsiVersion?: number,
          isChecked?: boolean
        ) => {
          return !channelMode || channelMode === "Digital" || isChecked;
        },
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        isInputInvalid: (channelMode?: string, val?: any) => {
          if (!channelMode) return true;
          if (channelMode === "Digital") return false;
          return !val || val.length === 0;
        },
      },
      {
        type: "HEX",
        label:
          EDIT_FORM_FIELDS_TRANSLATIONS[Page.DFSI_CHANNEL][
            "OUTBOUND-NETWORK-ACCESS-CODE"
          ].label,
        tooltipText:
          EDIT_FORM_FIELDS_TRANSLATIONS[Page.DFSI_CHANNEL][
            "OUTBOUND-NETWORK-ACCESS-CODE"
          ].tooltipText,
        name: "OUTBOUND-NETWORK-ACCESS-CODE",
        min: 0,
        max: 4095,
        disabled: (channelMode?: string) => {
          return channelMode === "Analog";
        },
        isInputInvalid: (channelMode?: string, val?: number) => {
          if (channelMode === "Analog") return false;
          if (val === 0) return false;

          if (!val) return true;

          if (val === 3966 || val === 3967) return true;

          if (val < 0 || val > 4095) return true;

          return false;
        },
        invalidText: FORM_VALIDATION_TRANSLATIONS.newtworkAccessCodeValidation(
          EDIT_FORM_FIELDS_TRANSLATIONS[Page.DFSI_CHANNEL][
            "OUTBOUND-NETWORK-ACCESS-CODE"
          ].label,
          "(0-4095)",
          "0xF7E (3966)",
          "0xF7F (3967)"
        ),
      },
      {
        type: "HEX",
        label:
          EDIT_FORM_FIELDS_TRANSLATIONS[Page.DFSI_CHANNEL][
            "INBOUND-NETWORK-ACCESS-CODE"
          ].label,
        tooltipText:
          EDIT_FORM_FIELDS_TRANSLATIONS[Page.DFSI_CHANNEL][
            "INBOUND-NETWORK-ACCESS-CODE"
          ].tooltipText,
        name: "INBOUND-NETWORK-ACCESS-CODE",
        min: 0,
        max: 4095,
        disabled: (channelMode?: string) => {
          return channelMode === "Analog";
        },
        isInputInvalid: (channelMode?: string, val?: number) => {
          if (channelMode === "Analog") return false;
          if (val === 0) return false;

          if (!val) return true;

          if (val === 3966 || val === 3967) return true;

          if (val < 0 || val > 4095) return true;

          return false;
        },
        invalidText: FORM_VALIDATION_TRANSLATIONS.newtworkAccessCodeValidation(
          EDIT_FORM_FIELDS_TRANSLATIONS[Page.DFSI_CHANNEL][
            "INBOUND-NETWORK-ACCESS-CODE"
          ].label,
          "(0-4095)",
          "0xF7E (3966)",
          "0xF7F (3967)"
        ),
      },
      {
        type: "NUMBER",
        label:
          EDIT_FORM_FIELDS_TRANSLATIONS[Page.DFSI_CHANNEL]["OTA-GROUP-ID"]
            .label,
        tooltipText:
          EDIT_FORM_FIELDS_TRANSLATIONS[Page.DFSI_CHANNEL]["OTA-GROUP-ID"]
            .tooltipText,
        name: "OTA-GROUP-ID",
        min: 1,
        max: 65535,
        invalidText: null,
        disabled: (channelMode?: string) => {
          return channelMode === "Analog";
        },
        isInputInvalid: (channelMode?: string, val?: number) => {
          if (!channelMode) return true;
          if (channelMode === "Analog") return false;

          if (!val) return true;

          if (val < 1 || val > 65535) return true;

          return false;
        },
      },
    ],
  },
];

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const EDIT_DFSI_GROUP_FORM_FIELDS: any = [
  {
    cols: 2,
    fields: [
      {
        type: "NUMBER",
        label: EDIT_FORM_FIELDS_TRANSLATIONS[Page.DFSI_GROUP].SLN.label,
        tooltipText:
          EDIT_FORM_FIELDS_TRANSLATIONS[Page.DFSI_GROUP].SLN.tooltipText,
        name: "SLN",
        min: 0,
        max: 65535,
        isInputInvalid: (val?: number, encryption?: boolean) => {
          if (!encryption) return false;
          if (val === 0) return false;

          if (!val) return true;

          if (val < 0 || val > 65535) return true;

          return false;
        },
      },
      {
        type: "TOGGLE",
        label:
          EDIT_FORM_FIELDS_TRANSLATIONS[Page.DFSI_GROUP]["ENCRYPTION-ENABLED"]
            .label,
        tooltipText:
          EDIT_FORM_FIELDS_TRANSLATIONS[Page.DFSI_GROUP]["ENCRYPTION-ENABLED"]
            .tooltipText,
        name: "ENCRYPTION-ENABLED",
      },
      {
        type: "SearchableMultiSelect",
        label:
          EDIT_FORM_FIELDS_TRANSLATIONS[Page.DFSI_GROUP]["CHANNEL-IDS"].label,
        tooltipText:
          EDIT_FORM_FIELDS_TRANSLATIONS[Page.DFSI_GROUP]["CHANNEL-IDS"]
            .tooltipText,
        name: "CHANNEL-IDS",
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        isInputInvalid: (val?: any) => {
          if (!val || val.length < 1) return true;
          return false;
        },
      },
    ],
  },
];

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const EDIT_LMR_GROUP_PROFILE_FORM_FIELDS: any = [
  {
    cols: 2,
    fields: [
      {
        type: "NUMBER",
        label:
          EDIT_FORM_FIELDS_TRANSLATIONS[Page.LMR_GROUP].GROUP_PROFILE[
            "GROUP-ACCESS-PERMISSION"
          ].label,
        tooltipText:
          EDIT_FORM_FIELDS_TRANSLATIONS[Page.LMR_GROUP].GROUP_PROFILE[
            "GROUP-ACCESS-PERMISSION"
          ].tooltipText,
        name: "GROUP-ACCESS-PERMISSION",
        invalidText: null,
        min: 0,
        max: 1,
      },
      {
        type: "NUMBER",
        label:
          EDIT_FORM_FIELDS_TRANSLATIONS[Page.LMR_GROUP].GROUP_PROFILE[
            "GROUP-EMERGENCY-CAPABLE"
          ].label,
        tooltipText:
          EDIT_FORM_FIELDS_TRANSLATIONS[Page.LMR_GROUP].GROUP_PROFILE[
            "GROUP-EMERGENCY-CAPABLE"
          ].tooltipText,
        name: "GROUP-EMERGENCY-CAPABLE",
        invalidText: null,
        min: 0,
        max: 1,
      },
      {
        type: "NUMBER",
        label:
          EDIT_FORM_FIELDS_TRANSLATIONS[Page.LMR_GROUP].GROUP_PROFILE[
            "GROUP-CC-SETUP-TIME"
          ].label,
        tooltipText:
          EDIT_FORM_FIELDS_TRANSLATIONS[Page.LMR_GROUP].GROUP_PROFILE[
            "GROUP-CC-SETUP-TIME"
          ].tooltipText,
        name: "GROUP-CC-SETUP-TIME",
        invalidText: null,
        min: 0,
        max: 32767,
      },
      {
        type: "NUMBER",
        label:
          EDIT_FORM_FIELDS_TRANSLATIONS[Page.LMR_GROUP].GROUP_PROFILE[
            "GROUP-SECURITY"
          ].label,
        tooltipText:
          EDIT_FORM_FIELDS_TRANSLATIONS[Page.LMR_GROUP].GROUP_PROFILE[
            "GROUP-SECURITY"
          ].tooltipText,
        name: "GROUP-SECURITY",
        invalidText: null,
        min: 1,
        max: 3,
      },
      {
        type: "NUMBER",
        label:
          EDIT_FORM_FIELDS_TRANSLATIONS[Page.LMR_GROUP].GROUP_PROFILE[
            "GROUP-RFSS-ID"
          ].label,
        tooltipText:
          EDIT_FORM_FIELDS_TRANSLATIONS[Page.LMR_GROUP].GROUP_PROFILE[
            "GROUP-RFSS-ID"
          ].tooltipText,
        name: "GROUP-RFSS-ID",
        invalidText: null,
        min: 0,
        max: 65535,
      },
      {
        type: "NUMBER",
        label:
          EDIT_FORM_FIELDS_TRANSLATIONS[Page.LMR_GROUP].GROUP_PROFILE[
            "GROUP-SLN"
          ].label,
        tooltipText:
          EDIT_FORM_FIELDS_TRANSLATIONS[Page.LMR_GROUP].GROUP_PROFILE[
            "GROUP-SLN"
          ].tooltipText,
        name: "GROUP-SLN",
        invalidText: null,
        min: 0,
        max: 4095,
      },
    ],
  },
];

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const EDIT_MCPTT_GROUP_PROFILE_FORM_FIELDS: any = [
  {
    cols: 2,
    fields: [
      {
        type: "NUMBER",
        label:
          EDIT_FORM_FIELDS_TRANSLATIONS[Page.MCPTT_GROUP].GROUP_PROFILE[
            "GROUP-ACCESS-PERMISSION"
          ].label,
        tooltipText:
          EDIT_FORM_FIELDS_TRANSLATIONS[Page.MCPTT_GROUP].GROUP_PROFILE[
            "GROUP-ACCESS-PERMISSION"
          ].tooltipText,
        name: "GROUP-ACCESS-PERMISSION",
        invalidText: null,
        min: 0,
        max: 1,
      },
      {
        type: "NUMBER",
        label:
          EDIT_FORM_FIELDS_TRANSLATIONS[Page.MCPTT_GROUP].GROUP_PROFILE[
            "GROUP-EMERGENCY-CAPABLE"
          ].label,
        tooltipText:
          EDIT_FORM_FIELDS_TRANSLATIONS[Page.MCPTT_GROUP].GROUP_PROFILE[
            "GROUP-EMERGENCY-CAPABLE"
          ].tooltipText,
        name: "GROUP-EMERGENCY-CAPABLE",
        invalidText: null,
        min: 0,
        max: 1,
      },
      {
        type: "NUMBER",
        label:
          EDIT_FORM_FIELDS_TRANSLATIONS[Page.MCPTT_GROUP].GROUP_PROFILE[
            "GROUP-CC-SETUP-TIME"
          ].label,
        tooltipText:
          EDIT_FORM_FIELDS_TRANSLATIONS[Page.MCPTT_GROUP].GROUP_PROFILE[
            "GROUP-CC-SETUP-TIME"
          ].tooltipText,
        name: "GROUP-CC-SETUP-TIME",
        invalidText: null,
        min: 0,
        max: 32767,
      },
      {
        type: "NUMBER",
        label:
          EDIT_FORM_FIELDS_TRANSLATIONS[Page.MCPTT_GROUP].GROUP_PROFILE[
            "GROUP-SECURITY"
          ].label,
        tooltipText:
          EDIT_FORM_FIELDS_TRANSLATIONS[Page.MCPTT_GROUP].GROUP_PROFILE[
            "GROUP-SECURITY"
          ].tooltipText,
        name: "GROUP-SECURITY",
        invalidText: null,
        min: 1,
        max: 3,
      },
      {
        type: "NUMBER",
        label:
          EDIT_FORM_FIELDS_TRANSLATIONS[Page.MCPTT_GROUP].GROUP_PROFILE[
            "GROUP-EXPIRATION-PERIOD"
          ].label,
        tooltipText:
          EDIT_FORM_FIELDS_TRANSLATIONS[Page.MCPTT_GROUP].GROUP_PROFILE[
            "GROUP-EXPIRATION-PERIOD"
          ].tooltipText,
        name: "GROUP-EXPIRATION-PERIOD",
        invalidText: null,
        min: 14400,
        max: 4294967295,
      },
      {
        type: "NUMBER",
        label:
          EDIT_FORM_FIELDS_TRANSLATIONS[Page.MCPTT_GROUP].GROUP_PROFILE[
            "GROUP-INTERRUPT-MODE"
          ].label,
        tooltipText:
          EDIT_FORM_FIELDS_TRANSLATIONS[Page.MCPTT_GROUP].GROUP_PROFILE[
            "GROUP-INTERRUPT-MODE"
          ].tooltipText,
        name: "GROUP-INTERRUPT-MODE",
        invalidText: null,
        min: 0,
        max: 2,
      },
      {
        type: "NUMBER",
        label:
          EDIT_FORM_FIELDS_TRANSLATIONS[Page.MCPTT_GROUP].GROUP_PROFILE[
            "GROUP-RF-HANG-TIME"
          ].label,
        tooltipText:
          EDIT_FORM_FIELDS_TRANSLATIONS[Page.MCPTT_GROUP].GROUP_PROFILE[
            "GROUP-RF-HANG-TIME"
          ].tooltipText,
        name: "GROUP-RF-HANG-TIME",
        invalidText: null,
        min: 0,
        max: 32676,
      },
      {
        type: "NUMBER",
        label:
          EDIT_FORM_FIELDS_TRANSLATIONS[Page.MCPTT_GROUP].GROUP_PROFILE[
            "GROUP-EMERGENCY-PREEMPTION"
          ].label,
        tooltipText:
          EDIT_FORM_FIELDS_TRANSLATIONS[Page.MCPTT_GROUP].GROUP_PROFILE[
            "GROUP-EMERGENCY-PREEMPTION"
          ].tooltipText,
        name: "GROUP-EMERGENCY-PREEMPTION",
        invalidText: null,
        min: 0,
        max: 1,
      },
      {
        type: "NUMBER",
        label:
          EDIT_FORM_FIELDS_TRANSLATIONS[Page.MCPTT_GROUP].GROUP_PROFILE[
            "GROUP-SLN"
          ].label,
        tooltipText:
          EDIT_FORM_FIELDS_TRANSLATIONS[Page.MCPTT_GROUP].GROUP_PROFILE[
            "GROUP-SLN"
          ].tooltipText,
        name: "GROUP-SLN",
        invalidText: null,
        min: 0,
        max: 4095,
      },
      {
        type: "NUMBER",
        label:
          EDIT_FORM_FIELDS_TRANSLATIONS[Page.MCPTT_GROUP].GROUP_PROFILE[
            "GROUP-PRIORITY"
          ].label,
        tooltipText:
          EDIT_FORM_FIELDS_TRANSLATIONS[Page.MCPTT_GROUP].GROUP_PROFILE[
            "GROUP-PRIORITY"
          ].tooltipText,
        name: "GROUP-PRIORITY",
        invalidText: null,
        min: 0,
        max: 10,
      },
    ],
  },
];

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const EDIT_IKI_CONNECTION_FORM_FIELDS: any = [
  {
    cols: 2,
    fields: [
      {
        type: "TEXT",
        label:
          EDIT_FORM_FIELDS_TRANSLATIONS[Page.IKI_CONNECTION]["IKI-NAME"].label,
        tooltipText:
          EDIT_FORM_FIELDS_TRANSLATIONS[Page.IKI_CONNECTION]["IKI-NAME"]
            .tooltipText,
        name: "IKI-NAME",
        isInputInvalid: (val?: string) => {
          if (!val || val.length === 0) return true;
          if (val.toUpperCase().includes("IWF")) return true;
          return false;
        },
        invalidText: FORM_VALIDATION_TRANSLATIONS.reservedIdentifier({
          fieldName:
            EDIT_FORM_FIELDS_TRANSLATIONS[Page.IKI_CONNECTION]["IKI-NAME"]
              .label,
          reservedWord: "IWF",
        }),
      },
    ],
  },
  {
    cols: 2,
    fields: [
      {
        type: "TEXT",
        label:
          EDIT_FORM_FIELDS_TRANSLATIONS[Page.IKI_CONNECTION]["IKI-IPV4-ADDR"]
            .label,
        tooltipText:
          EDIT_FORM_FIELDS_TRANSLATIONS[Page.IKI_CONNECTION]["IKI-IPV4-ADDR"]
            .tooltipText,
        name: "IKI-IPV4-ADDR",
        isInputInvalid: (val?: string) => {
          if (!val || val.length === 0) return true;
          if (
            !/^(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)$/.test(
              val
            )
          ) {
            return true;
          }

          return false;
        },
        invalidText: FORM_VALIDATION_TRANSLATIONS.IPV4Validation(
          EDIT_FORM_FIELDS_TRANSLATIONS[Page.IKI_CONNECTION]["IKI-IPV4-ADDR"]
            .label
        ),
      },
      {
        type: "NUMBER",
        label:
          EDIT_FORM_FIELDS_TRANSLATIONS[Page.IKI_CONNECTION]["IKI-PORT"].label,
        tooltipText:
          EDIT_FORM_FIELDS_TRANSLATIONS[Page.IKI_CONNECTION]["IKI-PORT"]
            .tooltipText,
        name: "IKI-PORT",
        min: 1024,
        max: 65535,
      },
      {
        type: "NUMBER",
        label:
          EDIT_FORM_FIELDS_TRANSLATIONS[Page.IKI_CONNECTION][
            "IKI-RADIO-SET-IDENTIFIER"
          ].label,
        tooltipText:
          EDIT_FORM_FIELDS_TRANSLATIONS[Page.IKI_CONNECTION][
            "IKI-RADIO-SET-IDENTIFIER"
          ].tooltipText,
        name: "IKI-RADIO-SET-IDENTIFIER",
        min: 1,
        max: 9999999,
      },
      {
        type: "NUMBER",
        label:
          EDIT_FORM_FIELDS_TRANSLATIONS[Page.IKI_CONNECTION][
            "IWF-RADIO-SET-IDENTIFIER"
          ].label,
        tooltipText:
          EDIT_FORM_FIELDS_TRANSLATIONS[Page.IKI_CONNECTION][
            "IWF-RADIO-SET-IDENTIFIER"
          ].tooltipText,
        name: "IWF-RADIO-SET-IDENTIFIER",
        min: 1,
        max: 9999999,
      },
    ],
  },
  {
    cols: 1,
    fields: [
      {
        type: "FILE",
        label:
          EDIT_FORM_FIELDS_TRANSLATIONS[Page.IKI_CONNECTION][
            "UPLOAD-CERTIFICATE"
          ].label,
        tooltipText:
          EDIT_FORM_FIELDS_TRANSLATIONS[Page.IKI_CONNECTION][
            "UPLOAD-CERTIFICATE"
          ].tooltipText,
        name: "IKI-CERTIFICATE",
      },
    ],
  },
];
